import { defineComponent as _defineComponent } from 'vue'
import Targets from '@/components/targets/Targets.vue';
import { Customer } from '@/models/tenant';
import { ConsoleEnum } from '@/models/enums/ConsoleEnum';
import { usersService } from '@/services/users.service';
import { computed } from 'vue';
import { currentUser } from '@/utils/permissionUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerTarget',
  props: {
    customer: null
  },
  setup(__props: any) {

const props = __props as {
  customer: Customer;
};



const hasWCC = computed(
  (): boolean =>
    props.customer.hasDatahub &&
    (usersService.store.current().isGlobalAdmin ||
      currentUser().consoles.includes(ConsoleEnum.WCC)),
);

const hasBC = computed(
  (): boolean =>
    props.customer.hasSmbs &&
    (usersService.store.current().isGlobalAdmin ||
      currentUser().consoles.includes(ConsoleEnum.BC)),
);

return { __sfc: true,props, hasWCC, hasBC, Targets, ConsoleEnum }
}

})